import React, { ReactNode, memo } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'
import { brandColors } from 'transfix-ui/theme/colors'

export interface IDetailsCardRowProps {
  title: string
  value: ReactNode
  loading: boolean
}

const useDetailsCardRowStyles = makeStyles(theme => ({
  title: {
    color: brandColors.coolGray5,
    whiteSpace: 'nowrap',
  },
  value: {
    textAlign: 'right',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    gap: theme.spacing(2),
  },
}))

const CarrierOptionsCardRow = memo<IDetailsCardRowProps>(({ loading, title, value }) => {
  const classes = useDetailsCardRowStyles()
  return (
    <div>
      <div className={classes.flexRow}>
        <Typography variant='body1' className={classes.title} component='div'>
          {title}
        </Typography>
        {loading ? (
          <Skeleton variant='text' width={150} />
        ) : (
          <div className={classes.value}>{value}</div>
        )}
      </div>
    </div>
  )
})

export default CarrierOptionsCardRow
